export enum Entities {
  PROFIT_ENTITY = 'A',
  NON_PROFIT_ENTITY = 'B',
  INTERNATIONAL_ORGANIZATION = 'C',
  PUBLIC_SECTOR = 'D',
  OTHER = 'E'
}

export const TYPE_ENTITY = {
  PROFIT_ENTITY: 'A',
  NON_PROFIT_ENTITY: 'B',
  INTERNATIONAL_ORGANIZATION: 'C',
  PUBLIC_SECTOR: 'D',
  OTHER: 'E'
}

export const NAME_ENTITY = {
  A: 'ENTIDAD LUCRATIVA',
  B: 'ENTIDAD NO LUCRATIVA',
  C: 'ORGANISMO INTERNACIONAL, MISIÓN DIPLOMÁTICA O CONSULAR',
  D: 'SECTOR PÚBLICO',
  E: 'OTRA'
}

export const CATALOG_TYPE_ENTITY = [
  {
    value: TYPE_ENTITY.PROFIT_ENTITY,
    label: NAME_ENTITY.A
  },
  {
    value: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_ENTITY.B
  },
  {
    value: TYPE_ENTITY.INTERNATIONAL_ORGANIZATION,
    label: NAME_ENTITY.C
  },
  {
    value: TYPE_ENTITY.PUBLIC_SECTOR,
    label: NAME_ENTITY.D
  },
  {
    value: TYPE_ENTITY.OTHER,
    label: NAME_ENTITY.E
  }
]
